<script context="module">
    // Licensed under Gnu Public License version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;

    /**
     * Extracts the component's parameters from an object.
     * @param {object} term
     * @returns {mathExpressionTerm}
     */
    export function termProps(term) {
        const { type, value, label, ariaLabel } = term;
        return { type, value, label, ariaLabel };
    }
</script>

<script>
    import { __, generateElementId } from '@oat-sa-private/ui-core';

    /**
     * @typedef {object} mathExpressionTerm
     * @property {string} type - The type of term. See @oat-sa/tao-calculator/types
     * @property {string} value - The actual value of the term
     * @property {string} label - The displayed label for the term
     */

    export let type = '';
    export let value = '';
    export let label = '';
    export let ariaLabel = '';

    const exponentPrefixAriaLabel = __('to the power of');
    const exponentPrefixElementId = generateElementId('exponentPrefix');
    const exponentValueElementId = generateElementId('exponentValue');

    const exponentType = 'exponent';
</script>

<style>
    [data-type='exponent'] {
        vertical-align: super;
        font-size: smaller;
    }

    [data-type='variable'] {
        font-weight: bold;
    }

    [data-type='function']:not([data-value*='rt']) {
        padding-right: 0.3em;
    }
    .expressionSRHelper {
        display: none;
    }
</style>

{#if type === exponentType}
    <span id={exponentPrefixElementId} class="expressionSRHelper">{exponentPrefixAriaLabel}</span>
    {#if Array.isArray(label)}
        <span
            data-value={value}
            data-type={type}
            aria-labelledby={`${exponentPrefixElementId} ${exponentValueElementId}`}
            id={exponentValueElementId}>
            {#each label as term}<svelte:self {...termProps(term)} />{/each}
        </span>
    {:else}
        <span
            data-value={value}
            data-type={type}
            aria-labelledby={`${exponentPrefixElementId} ${exponentValueElementId}`}
            id={exponentValueElementId}>{@html label}</span>
    {/if}
{:else if Array.isArray(label)}
    <span data-value={value} data-type={type}>
        {#each label as term}<svelte:self {...termProps(term)} />{/each}
    </span>
{:else}
    <span data-value={value} data-type={type} aria-label={ariaLabel}>{@html label}</span>
{/if}
